import axios, { AxiosProgressEvent } from 'axios';

interface UploadFileParams {
  url: string;
  file: File | ReadableStream;
  signal?: AbortSignal;
  onUploadProgress?: (progress: AxiosProgressEvent) => void;
  fileSize: number;
}

// S E R V I C E

export const uploadFileService = (params: UploadFileParams) => {
  const { url, file, onUploadProgress, fileSize } = params;
  return axios.put(url, file, {
    onUploadProgress,
    headers: { 'x-amz-storage-class': 'INTELLIGENT_TIERING', 'x-amz-content-length': fileSize },
    signal: params.signal,
  });
};

export const downloadFile = async (url: Url, cb: (progress: number) => void) => {
  return await axios.get(url, {
    responseType: 'blob',
    onDownloadProgress(e) {
      cb(e.progress ?? 0);
    },
  });
};
